import React from 'react';
import { BookCard, BookProps } from './BookCard';
import { motion } from 'framer-motion';
const CATALOG_BOOKS: BookProps[] = [{
  id: '1',
  title: 'Hábitos de Acero',
  author: 'Marcos Silva',
  price: 12.5,
  rating: 4.8,
  color: 'bg-gradient-to-br from-emerald-600 to-teal-800',
  category: 'Desarrollo Personal'
}, {
  id: '2',
  title: 'Código Limpio en React',
  author: 'Ana Martínez',
  price: 18.99,
  rating: 4.9,
  color: 'bg-gradient-to-br from-blue-600 to-indigo-800',
  category: 'Tecnología'
}, {
  id: '3',
  title: 'El Arte de Invertir',
  author: 'Carlos Ruiz',
  price: 15.0,
  rating: 4.6,
  color: 'bg-gradient-to-br from-amber-600 to-orange-800',
  category: 'Negocios'
}, {
  id: '4',
  title: 'Sombras en la Ciudad',
  author: 'Laura Gómez',
  price: 9.99,
  rating: 4.5,
  color: 'bg-gradient-to-br from-slate-700 to-slate-900',
  category: 'Misterio'
}, {
  id: '5',
  title: 'Breve Historia del Mañana',
  author: 'David Chen',
  price: 14.2,
  rating: 4.7,
  color: 'bg-gradient-to-br from-purple-600 to-fuchsia-800',
  category: 'Ciencia'
}, {
  id: '6',
  title: 'Liderazgo Zen',
  author: 'Sofía Reyes',
  price: 11.99,
  rating: 4.4,
  color: 'bg-gradient-to-br from-rose-500 to-red-700',
  category: 'Negocios'
}, {
  id: '7',
  title: 'Mentes Cuánticas',
  author: 'Dr. Alan Turing',
  price: 16.5,
  rating: 4.8,
  color: 'bg-gradient-to-br from-cyan-600 to-blue-800',
  category: 'Ciencia'
}, {
  id: '8',
  title: 'El Jardín Olvidado',
  author: 'Carmen Vega',
  price: 10.5,
  rating: 4.3,
  color: 'bg-gradient-to-br from-green-600 to-emerald-800',
  category: 'Ficción'
}];
export function Catalog() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" id="catalogo" data-id="element-26">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-28">
          <h2 className="text-3xl font-bold text-slate-900 mb-2" data-id="element-29">
            Catálogo Completo
          </h2>
          <p className="text-slate-600" data-id="element-30">
            Explora nuestra colección de e-books por género y autor.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex gap-2" data-id="element-31">
          <select className="bg-white border border-slate-200 text-slate-700 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block p-2.5 shadow-sm" data-id="element-32">
            <option data-id="element-33">Más recientes</option>
            <option data-id="element-34">Precio: Menor a Mayor</option>
            <option data-id="element-35">Precio: Mayor a Menor</option>
            <option data-id="element-36">Mejor valorados</option>
          </select>
        </motion.div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-37">
        {CATALOG_BOOKS.map((book, index) => <BookCard key={book.id} book={book} delay={index * 0.1} data-id="element-38" />)}
      </div>

      <div className="mt-12 text-center" data-id="element-39">
        <button className="inline-flex items-center justify-center px-6 py-3 border border-slate-300 shadow-sm text-base font-medium rounded-full text-slate-700 bg-white hover:bg-slate-50 transition-colors" data-id="element-40">
          Cargar más libros
        </button>
      </div>
    </section>;
}